const addStaticHost = (urlkey) => {
  if (urlkey.indexOf("http") == 0) {
    return urlkey
  }
  return 'http://statica.xuantu.pro/' + urlkey
}


export function thumbnail(urkey){
  if (!urkey) {
    return urkey
  }

  if (urkey.indexOf('x-oss-process=image') > 0) {
    // 移除已有的处理参数
    urkey = urkey.split('?')[0]
  }
  if (urkey.indexOf(".webp") > -1) {
    return addStaticHost(urkey)
  }

  return addStaticHost(urkey) + '?x-oss-process=image/auto-orient,1/resize,m_lfit,w_300/quality,q_90'
}
export function removeHost(url) {
  if (!url) {
    return url
  }
  if (url.indexOf("http") > -1) {
    return url
  }
  return url.replace('http://statica.xuantu.pro/', '')
}

export function  rawImage(urkey){
  if (!urkey) {
    return urkey
  }
  return addStaticHost(urkey)
}